import { buildEffectWithElementHook } from "../../_shared/elementForFeatureHook";
import { buildListenerOnDiff } from "../../_store/customScrollStoreDomain";
import { isAllPropsDefined } from "../../_utils/predicates";

export const useSetOffsetsOnScrollFeature = buildEffectWithElementHook(
    (element, store, extensions) =>
        buildListenerOnDiff(
            store,
            s => ({
                scrollLeft: s.horizontalDimension?.scrollMeasure,
                scrollTop: s.verticalDimension?.scrollMeasure,
            }),
            offsets => {
                if (isAllPropsDefined(offsets))
                    (
                        extensions?.setContainerOffsets ??
                        setHTMLElementContainerOffsets
                    )(offsets, element);
            }
        )
);

function setHTMLElementContainerOffsets(offsets, element: HTMLElement) {
    element.scrollLeft = offsets.scrollLeft;
    element.scrollTop = offsets.scrollTop;
}
